<template>
  <loader v-if="$store.state.loading" />
  <router-view></router-view>
</template>

<script>
import Loader from './components/Loader.vue'

export default {
  name: 'App',
  components: {
    Loader
  }
}
</script>

<style lang="scss">
//Dashkit theme
@import './theme/scss/theme.scss';

</style>
